import { render, staticRenderFns } from "./Pianhua.vue?vue&type=template&id=365f9586&"
import script from "./Pianhua.vue?vue&type=script&lang=js&"
export * from "./Pianhua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports